import angular from 'angular';
import productsModule from './products/products.module';
import sharingModule from './sharing/sharing.module';
import taggingModule from './tagging/tagging.module';

const assetsModule = angular.module('admin.assets', [
	productsModule,
	sharingModule,
	taggingModule
]);

export default assetsModule.name;
